import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn, MDBBtnGroup ,MDBIcon, MDBContainer} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import WarningBox from '../components/WarningBox';


import { toast, ToastContainer} from "mdbreact";



const AddEditUserAccess=(props)=>{

  const useMountEffect = (functionName) => useEffect(functionName, [])

  

       
  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [frm, setValues] = useState({
    code:props.code,
    userrole: '',
    usercode:props.usercode,
    usertoken: sessionStorage.getItem("msal.uc")


    
});
     
const [roleOptions, setRoleOptions] = useState([]);



const  handleChange = objName => (selOption) => {
  
    setValues({ ...frm, [objName]: selOption });
   
 };

  const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;
      
      setValues({ ...frm, [name]: value });
    }
    else
    {
      setValues({ ...frm, [name]: value });
    }

   

};

      

   
  function submitHandler (event){
        event.preventDefault();
        event.target.className += " was-validated";
        
         saveuseraccessdetails();

  }
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


   

    
   
  const loadAllRoles=()=>
  {
 
        Axios.get(props.apiServer  + '/getallroles',bearer)
        .then(res => {
        
         setRoleOptions(res.data);
          
    
         
      
        
        })
        .catch(error => {
          setErrorMessage(error);
            toggleWarningBox();
        
      
        });  
    
    
     
  } 


  const loaduseraccessdetails=()=>
  {
    
    Axios.get(props.apiServer + '/loaduseraccessdetails?acode=' + props.code ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
         
            setValues({ ...frm,
              code:res.data.code,
              userrole: {value: res.data.roleid, label: res.data.roledescription}
   
            });   
                  
                  
        }
        else
        {
       
            console.log('No record');
        
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const saveuseraccessdetails=()=> {
    
     const data =frm;
   
     Axios.post(props.apiServer + "/saveuseraccessdetails", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
            setValues({...frm, code : res.data.code});
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
              props.refreshGrid();
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });
   
 }



 
 const deleteuseraccess=()=>
 {
    const data =frm;

   
     Axios.post(props.apiServer + "/deleteuseraccess", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
        props.refreshGrid();
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });

  
   
        
 }

 
 const [isAdmin,checkAdmin]=useState(0);

      
 function checkAdminAccess() {
     
 
   Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
    .then(res => {
    
       checkAdmin(0);
       checkAdmin(res.data[0].isadmin);
   
    })
  
    .catch(error => {
     
     console.log(error);
    });  
   
  
  
  
  }


 useMountEffect(loadAllRoles);
useMountEffect(loaduseraccessdetails);



    return (
        <React.Fragment>
        
           
            <MDBRow>
                <MDBCol md="10">
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     
                 
                   
                                    
                    {/* usercode */}
                    <MDBRow hidden>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.usercode} 
                            id="usercode"  
                            label="usercode" 
                           hidden
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>
    

                      
                    {/* code */}
                    <MDBRow hidden >
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.code} 
                            id="code"  
                            label="code" 
                          hidden
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>
                  
              
                    <MDBRow>
                        <MDBCol md="4">
                     
                         <Select
                            placeholderText="Select role"
                            isSearchable
                            value={frm.userrole}
                            onChange={handleChange("userrole")}
                            options={roleOptions}
                            required
                          /> 
                          <div className="invalid-feedback">
                                 This field is required!
                            </div>
                                 <div className="valid-feedback">Looks good!</div>

                        <br/>
                        </MDBCol>
                    </MDBRow>


                   <MDBRow>
                       <MDBCol md="6">
                       <MDBBtn className="blue lighten-1" type="submit">
                        Save
                    </MDBBtn>  {props.code==="" ?
                           (<MDBBtn id="cmdClose" className="blue lighten-4 blue-text"  onClick={props.toggleModal}>
                           Close
                       </MDBBtn>):(  
                     <MDBBtn color="danger" onClick={deleteuseraccess}>
                     Delete
                 </MDBBtn>
                    
                    )}
                       </MDBCol>
                       <MDBCol md="6">
                     
                       
                       </MDBCol>
                   </MDBRow>

                   
                  
                    </form>
                  
                </MDBCol>
            </MDBRow>
            
            <ToastContainer
            hideProgressBar={true}
            newestOnTop={true}
            autoClose={5000}/>

        
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default AddEditUserAccess
